import { type ComponentPropsWithoutRef, type ComponentRef, forwardRef } from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { cn } from '@/utils/tailwind.util';
import { BaseDropdownContainerUI } from '../base/BaseDropdownContainerUI';
export const SelectContent = forwardRef<ComponentRef<typeof SelectPrimitive.Content>, ComponentPropsWithoutRef<typeof SelectPrimitive.Content> & {
  showScrollbar?: boolean;
}>(({
  className,
  children,
  position = 'popper',
  showScrollbar = true,
  ...props
}, ref) => {
  return <SelectPrimitive.Content asChild ref={ref} position={position} {...props}>
        <BaseDropdownContainerUI className={cn(position === 'popper' && 'data-[side=bottom]:translate-y-0 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:translate-y-0', className)}>
          <div className="w-full">
            <SelectPrimitive.Viewport style={showScrollbar ? {
          scrollbarWidth: 'thin',
          msOverflowStyle: 'auto',
          WebkitOverflowScrolling: 'touch'
        } : undefined} className={cn('px-xs py-3xs', 'w-[var(--radix-select-trigger-width)]', className)}>
              {children}
            </SelectPrimitive.Viewport>
          </div>
        </BaseDropdownContainerUI>
      </SelectPrimitive.Content>;
});
SelectContent.displayName = SelectPrimitive.Content.displayName;